import { useState } from 'react';

interface ServicesProps {
  activeFilter: string;
  setActiveFilter: (filter: string) => void;
}

type PortfolioItem =
  | { id: number; type: 'image'; category: string; title: string; image: string }
  | { id: number; type: 'video'; category: string; title: string; thumbnail: string; videoUrl: string; description: string };

export default function Services({ activeFilter, setActiveFilter }: ServicesProps) {
  const [modalVideo, setModalVideo] = useState<{ url: string; title: string } | null>(null);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  const performanceKeywords = ['감동', '메시지', '몰입'];
  const experienceKeywords = ['창의', '교육', '추억'];

  const portfolioItems: PortfolioItem[] = [
    { id: 1, type: 'image', category: '공연', title: '한국수력원자력(주) 월성원자력본부 임직원 힐링 & 애사심 증진 샌드아트 공연', image: 'https://public.readdy.ai/ai/img_res/7d41f435fd5c9a619f1d90e2e9b08aca.jpg' },
    { id: 2, type: 'image', category: '공연', title: '[유치원 샌드아트 공연] 대구 연세유치원 샌드아트 공연', image: 'https://readdy.ai/api/search-image?query=Warm%20and%20joyful%20sand%20art%20performance%20for%20kindergarten%20children%20in%20a%20bright%20school%20auditorium%2C%20professional%20sand%20artist%20performing%20on%20illuminated%20light%20box%20stage%2C%20excited%20young%20children%20watching%20in%20amazement%2C%20colorful%20cheerful%20atmosphere%20with%20soft%20warm%20lighting%2C%20cute%20animal%20and%20fairy%20tale%20shapes%20drawn%20in%20sand%2C%20heartwarming%20educational%20performance%20event%20photography%2C%208k%20quality%2C%20vibrant%20and%20friendly%20atmosphere&width=600&height=400&seq=kindergarten-sandart-daegu-v1&orientation=landscape' },
    { id: 3, type: 'image', category: '체험', title: '[도서관 샌드아트] 크리스마스 샌드아트 공연 & 체험', image: 'https://readdy.ai/api/search-image?query=Magical%20Christmas%20sand%20art%20show%20performance%20in%20a%20cozy%20library%20setting%2C%20professional%20sand%20artist%20creating%20enchanting%20winter%20wonderland%20scenes%20with%20Santa%20Claus%20reindeer%20and%20snowflakes%20on%20a%20glowing%20illuminated%20light%20box%2C%20warm%20golden%20amber%20and%20cool%20silver%20light%20radiating%20through%20fine%20white%20sand%2C%20festive%20Christmas%20decorations%20with%20twinkling%20lights%20and%20red%20ribbons%20in%20the%20background%2C%20children%20and%20families%20watching%20in%20wonder%20and%20delight%2C%20heartwarming%20holiday%20atmosphere%20with%20soft%20cinematic%20lighting%2C%208k%20quality%20event%20photography&width=600&height=400&seq=library-christmas-sandart-show-v1&orientation=landscape' },
    {
      id: 7,
      type: 'video',
      category: '공연',
      title: '샌드아트 공연 하이라이트',
      thumbnail: 'https://img.youtube.com/vi/81U6fJgy0Hw/maxresdefault.jpg',
      videoUrl: 'https://www.youtube.com/watch?v=81U6fJgy0Hw',
      description: '샌드아트 공연 하이라이트',
    },
    { id: 4, type: 'image', category: '공연', title: '2025 울산광역시 북구청 종무식', image: 'https://readdy.ai/api/search-image?query=Elegant%20sand%20art%20performance%20at%20a%20formal%20government%20year-end%20ceremony%20in%20a%20grand%20public%20hall%2C%20professional%20sand%20artist%20creating%20beautiful%20flowing%20patterns%20of%20city%20skyline%20and%20community%20silhouettes%20on%20a%20glowing%20illuminated%20light%20box%20stage%2C%20warm%20golden%20amber%20light%20radiating%20through%20fine%20sand%2C%20dignified%20and%20celebratory%20atmosphere%20with%20official%20banners%20and%20stage%20decorations%2C%20rows%20of%20government%20officials%20and%20citizens%20watching%20with%20admiration%2C%20sophisticated%20civic%20event%20photography%20with%20cinematic%20lighting%2C%208k%20quality&width=600&height=400&seq=ulsan-bukgu-jongmusik-sandart-2025-v1&orientation=landscape' },
    { id: 5, type: 'image', category: '체험', title: '[학교 샌드아트] 부산 사상구청 주관 - 탄소중립·환경보호 샌드아트 공연 & 체험', image: 'https://readdy.ai/api/search-image?query=Inspiring%20eco-friendly%20sand%20art%20performance%20and%20workshop%20about%20carbon%20neutrality%20and%20environmental%20protection%2C%20professional%20sand%20artist%20creating%20stunning%20nature%20scenes%20with%20green%20forests%20trees%20animals%20and%20clean%20earth%20on%20a%20glowing%20illuminated%20light%20box%20stage%2C%20lush%20green%20and%20earthy%20tones%20radiating%20through%20fine%20sand%2C%20school%20children%20and%20students%20participating%20in%20hands-on%20sand%20art%20experience%20at%20small%20illuminated%20tables%2C%20educational%20environmental%20awareness%20event%20with%20eco%20banners%20and%20green%20decorations%2C%20warm%20natural%20lighting%20with%20cinematic%20depth%2C%208k%20quality%20event%20photography&width=600&height=400&seq=busan-sasang-eco-sandart-v1&orientation=landscape' },
    {
      id: 8,
      type: 'video',
      category: '체험',
      title: '체험 프로그램 영상',
      thumbnail: 'https://img.youtube.com/vi/8_i2tegsH20/maxresdefault.jpg',
      videoUrl: 'https://www.youtube.com/watch?v=8_i2tegsH20',
      description: '체험 프로그램 영상',
    },
    { id: 6, type: 'image', category: '공연', title: '구미시 가족센터 성과보고회 [가족과 마음을 잇는 샌드아트 축하공연]', image: 'https://readdy.ai/api/search-image?query=Heartwarming%20sand%20art%20celebration%20performance%20at%20a%20family%20community%20center%20achievement%20ceremony%2C%20professional%20sand%20artist%20drawing%20touching%20family%20silhouettes%20of%20parents%20and%20children%20holding%20hands%20on%20a%20glowing%20illuminated%20light%20box%20stage%2C%20warm%20golden%20amber%20light%20flowing%20through%20fine%20sand%2C%20emotional%20and%20joyful%20atmosphere%20with%20colorful%20family-themed%20decorations%20and%20banners%2C%20audience%20of%20families%20and%20community%20members%20watching%20with%20smiles%20and%20tears%20of%20joy%2C%20soft%20warm%20stage%20lighting%20creating%20an%20intimate%20celebratory%20mood%2C%20cinematic%20event%20photography%2C%208k%20quality&width=600&height=400&seq=gumi-family-center-sandart-celebration-v1&orientation=landscape' },
  ];

  const filteredPortfolio = activeFilter === '전체'
    ? portfolioItems
    : portfolioItems.filter(item => item.category === activeFilter);

  const getEmbedUrl = (url: string) => {
    if (!url || url === 'https://www.youtube.com/embed/') return null;
    const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/]+)/);
    if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1`;
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
    return url;
  };

  return (
    <section id="services" className="py-32 lg:py-40 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">

        {/* Section Title */}
        <div className="mb-20 lg:mb-28">
          <p className="text-xs font-medium tracking-widest uppercase text-primary mb-4">Services</p>
          <h2 className="text-3xl lg:text-5xl font-light text-black leading-tight tracking-tight">
            공연과 체험,<br />
            두 가지 핵심 서비스
          </h2>
        </div>

        {/* Performance Service */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 mb-28 lg:mb-36">
          <div className="order-2 lg:order-1 flex flex-col justify-center">
            <p className="text-xs font-medium tracking-widest uppercase text-primary mb-5">Performance</p>
            <h3 className="text-2xl lg:text-4xl font-light text-black mb-5">샌드아트 공연</h3>
            <p className="text-sm text-textGray font-light leading-relaxed mb-7">
              기업행사, 축제, 교육기관 등 다양한 행사에 맞춤형 샌드아트 공연을 제공합니다.
              고객의 이야기를 모래로 표현하여 감동적인 순간을 만들어드립니다.
            </p>
            <div className="flex items-center gap-6 mb-7">
              {performanceKeywords.map((keyword, index) => (
                <span key={index} className="text-sm text-textGray font-light tracking-wide">
                  {keyword}
                  {index < performanceKeywords.length - 1 && <span className="ml-6 text-lineGray">·</span>}
                </span>
              ))}
            </div>
            <div className="flex flex-wrap gap-2 mb-10">
              {['기업행사', '축제', '학교', '공공기관', '교육'].map((type, index) => (
                <span key={index} className="px-4 py-1.5 text-xs font-light tracking-wide text-black border border-lineGray hover:border-black transition-colors duration-300">
                  {type}
                </span>
              ))}
            </div>
            <button onClick={() => scrollToSection('contact')} className="self-start px-8 py-3 bg-black text-white text-xs font-medium tracking-wider uppercase hover:bg-black/80 hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer">
              공연 문의
            </button>
          </div>
          <div className="order-1 lg:order-2 group">
            <div className="aspect-[4/3] overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=Ultra%20high%20resolution%20professional%20sand%20art%20performance%20on%20luxury%20stage%2C%20elegant%20sand%20artist%20creating%20beautiful%20flowing%20patterns%20and%20artistic%20silhouettes%20on%20premium%20illuminated%20glass%20table%2C%20dramatic%20cinematic%20stage%20lighting%20with%20warm%20golden%20amber%20spotlights%2C%20sophisticated%20corporate%20event%20atmosphere%2C%208k%20quality%20event%20photography%20with%20shallow%20depth%20of%20field%2C%20minimalist%20elegant%20dark%20background&width=800&height=600&seq=service-perf-premium-v2-001&orientation=landscape" alt="샌드아트 공연" className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700" />
            </div>
          </div>
        </div>

        {/* Experience Service */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 mb-28 lg:mb-36">
          <div className="group">
            <div className="aspect-[4/3] overflow-hidden">
              <img src="https://readdy.ai/api/search-image?query=High%20quality%20children%20and%20families%20enjoying%20premium%20sand%20art%20workshop%20experience%2C%20participants%20creating%20colorful%20artistic%20sand%20patterns%20on%20luxury%20small%20illuminated%20tables%2C%20bright%20cheerful%20modern%20studio%20atmosphere%20with%20natural%20lighting%2C%20warm%20educational%20setting%2C%20happy%20people%20focused%20on%20creative%20activities%2C%20professional%20lifestyle%20photography%20with%20vibrant%20soft%20tones%2C%208k%20quality&width=800&height=600&seq=service-exp-premium-v2-001&orientation=landscape" alt="샌드아트 체험" className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700" />
            </div>
          </div>
          <div className="flex flex-col justify-center">
            <p className="text-xs font-medium tracking-widest uppercase text-primary mb-5">Experience</p>
            <h3 className="text-2xl lg:text-4xl font-light text-black mb-5">샌드아트 체험</h3>
            <p className="text-sm text-textGray font-light leading-relaxed mb-7">
              키즈, 가족, 단체를 위한 창의적인 샌드아트 체험 프로그램입니다.
              누구나 쉽게 참여할 수 있으며, 특별한 추억을 만들어드립니다.
            </p>
            <div className="flex items-center gap-6 mb-7">
              {experienceKeywords.map((keyword, index) => (
                <span key={index} className="text-sm text-textGray font-light tracking-wide">
                  {keyword}
                  {index < experienceKeywords.length - 1 && <span className="ml-6 text-lineGray">·</span>}
                </span>
              ))}
            </div>
            <div className="flex flex-wrap gap-2 mb-10">
              {['키즈 체험', '가족 체험', '단체 체험', '( 유·초·중·고 ) 체험'].map((type, index) => (
                <span key={index} className="px-4 py-1.5 text-xs font-light tracking-wide text-black border border-lineGray hover:border-black transition-colors duration-300">
                  {type}
                </span>
              ))}
            </div>
            <button onClick={() => scrollToSection('contact')} className="self-start px-8 py-3 bg-black text-white text-xs font-medium tracking-wider uppercase hover:bg-black/80 hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer">
              체험 문의
            </button>
          </div>
        </div>

        {/* Video Production */}
        <div className="py-14 lg:py-16 border-y border-lineGray mb-28 lg:mb-36">
          <div className="max-w-2xl mx-auto text-center">
            <p className="text-xs font-medium tracking-widest uppercase text-textGray mb-5">Video Production</p>
            <h3 className="text-xl lg:text-2xl font-light text-black mb-4">샌드아트 영상 제작</h3>
            <p className="text-sm text-textGray font-light leading-relaxed mb-8">
              특별한 메시지를 담은 샌드아트 영상을 제작해드립니다.
            </p>
            <button onClick={() => scrollToSection('contact')} className="px-6 py-2.5 text-xs font-medium tracking-wider uppercase text-black border border-black hover:bg-black hover:text-white hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer">
              영상 문의
            </button>
          </div>
        </div>

        {/* Portfolio */}
        <div>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-10">
            <div>
              <p className="text-xs font-medium tracking-widest uppercase text-primary mb-3">Portfolio</p>
              <h3 className="text-2xl lg:text-3xl font-light text-black">작업 사례</h3>
            </div>
            <div className="flex gap-8 mt-6 lg:mt-0">
              {['전체', '공연', '체험'].map((filter) => (
                <button
                  key={filter}
                  onClick={() => setActiveFilter(filter)}
                  className={`text-sm font-light tracking-wide transition-all duration-300 cursor-pointer pb-1 border-b ${
                    activeFilter === filter ? 'text-black border-black' : 'text-textGray border-transparent hover:text-black'
                  }`}
                >
                  {filter}
                </button>
              ))}
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredPortfolio.map((item) => {
              if (item.type === 'video') {
                const embedUrl = getEmbedUrl(item.videoUrl);
                const isEmpty = !embedUrl;
                return (
                  <div
                    key={item.id}
                    onClick={() => !isEmpty && setModalVideo({ url: embedUrl!, title: item.title })}
                    className={`group relative aspect-[3/2] overflow-hidden ${isEmpty ? 'cursor-default' : 'cursor-pointer'}`}
                  >
                    <img
                      src={item.thumbnail}
                      alt={item.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                    />
                    {/* Dark overlay */}
                    <div className="absolute inset-0 bg-black/40 group-hover:bg-black/55 transition-all duration-500" />

                    {/* Play button */}
                    <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
                      <div className={`w-14 h-14 flex items-center justify-center rounded-full border-2 border-white/80 bg-white/10 backdrop-blur-sm transition-all duration-300 ${isEmpty ? 'opacity-40' : 'group-hover:scale-110 group-hover:bg-white/20'}`}>
                        <i className="ri-play-fill text-white text-2xl ml-1" />
                      </div>
                      {isEmpty && (
                        <span className="text-white/60 text-xs tracking-wider font-light">영상 URL을 등록해 주세요</span>
                      )}
                    </div>

                    {/* Bottom info */}
                    <div className="absolute bottom-0 left-0 right-0 p-5">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="text-xs text-white/60 uppercase tracking-wider">{item.category}</span>
                        <span className="w-1 h-1 rounded-full bg-white/40" />
                        <span className="text-xs text-white/60 uppercase tracking-wider">Video</span>
                      </div>
                      <h4 className="text-sm text-white font-light">{item.title}</h4>
                    </div>
                  </div>
                );
              }

              const imageLinks: Record<number, string> = {
                1: 'https://m.blog.naver.com/PostView.naver?blogId=kildelee&logNo=224139224659&navType=by',
                2: 'https://m.blog.naver.com/PostView.naver?blogId=kildelee&logNo=224220162964&navType=by',
                3: 'https://m.blog.naver.com/PostView.naver?blogId=kildelee&logNo=224118127870&navType=by',
                4: 'https://m.blog.naver.com/PostView.naver?blogId=kildelee&logNo=224136203586&navType=by',
                5: 'https://m.blog.naver.com/PostView.naver?blogId=kildelee&logNo=224098373757&navType=by',
                6: 'https://m.blog.naver.com/PostView.naver?blogId=kildelee&logNo=224110230458&navType=by',
              };
              const link = imageLinks[item.id];

              // 준비중 카드 (id: 1)
              const cardContent = (
                <>
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-500">
                    <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                      <p className="text-xs text-white/70 uppercase tracking-wider mb-1">{item.category}</p>
                      <h4 className="text-sm text-white font-light">{item.title}</h4>
                    </div>
                  </div>
                </>
              );

              return link ? (
                <a key={item.id} href={link} target="_blank" rel="nofollow noopener noreferrer" className="group relative aspect-[3/2] overflow-hidden cursor-pointer block">
                  {cardContent}
                </a>
              ) : (
                <div key={item.id} className="group relative aspect-[3/2] overflow-hidden cursor-pointer">
                  {cardContent}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {modalVideo && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm"
          onClick={() => setModalVideo(null)}
        >
          <div
            className="relative w-full max-w-4xl mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              onClick={() => setModalVideo(null)}
              className="absolute -top-12 right-0 w-10 h-10 flex items-center justify-center text-white/70 hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-2xl" />
            </button>

            {/* Title */}
            <p className="text-white/60 text-xs tracking-widest uppercase mb-3">{modalVideo.title}</p>

            {/* Video iframe */}
            <div className="aspect-video w-full bg-black">
              <iframe
                src={modalVideo.url}
                title={modalVideo.title}
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
